import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Checkbox,
} from "@mui/material";
import { modalConfig, modalContent } from "./successModalData";
import CelebrationGif from "../../assets/animations/confetti.gif";

import "./index.scss";

const SuccessModal = ({
  open,
  onClose,
  onNext,
  warrantyChecked,
  onWarrantyChange,
}) => {
  // Only close on escape key or close button
  const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    if (onClose) {
      onClose(event, reason);
    }
  };

  const handleWarrantyToggle = (checked) => {
    if (onWarrantyChange) {
      onWarrantyChange({ target: { checked } });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
            width: "100vw",
            maxWidth: {
              xs: modalConfig.maxWidth.mobile,
              sm: modalConfig.maxWidth.desktop,
            },
            m: 0,
            overflowX: "hidden",
            display: "flex",
            alignItems: "center",
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          pt: 2,
          pb: 1,
          px: 1,
        }}
      >
        <img src={CelebrationGif} alt="celebration" height={38} width={38} />
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            mt: 1,
            letterSpacing: 0.3,
            fontSize: 16,
            lineHeight: 1.35,
          }}
        >
          {modalContent.title} <br /> {modalContent.subtitle}
        </Typography>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          textAlign: "center",
          p: 1,
          pt: 1.5,
          pb: 2,
          bgcolor: "#fafdff",
          width: "100%",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: 290, mx: "auto" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 0,
              mb: 1.2,
              width: "100%",
            }}
          >
            {/* Standard Warranty Button */}
            <Button
              variant="contained"
              disableElevation
              sx={{
                borderRadius: "8px 0 0 8px",
                mr: 0,
                minHeight: modalConfig.buttonHeight.mobile,
                border: "1px solid #1d72b8",
                background: "#24c27c",
                color: "#fff",
                fontWeight: 700,
                fontSize: 12,
                paddingLeft: 0.75,
                paddingRight: 0.75,
                flex: 1,
                lineHeight: 1.25,
                boxShadow: "none",
              }}
            >
              0 - 1 Year
            </Button>

            {/* Extended Warranty Button */}
            <Button
              variant="contained"
              disableElevation
              onClick={() => handleWarrantyToggle(!warrantyChecked)}
              sx={{
                borderRadius: "0 8px 8px 0",
                ml: 0,
                minHeight: modalConfig.buttonHeight.mobile,
                border: "1px solid #1d72b8",
                background: warrantyChecked ? "#24c27c" : "#fff",
                color: "#000",
                fontWeight: warrantyChecked ? 700 : 500,
                fontSize: 12,
                paddingLeft: 0.75,
                paddingRight: 0.75,
                flex: 1,
                lineHeight: 1.25,
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                boxShadow: "none",
                "&:hover": {
                  background: warrantyChecked ? "#1ea568" : "#eef6fa",
                },
              }}
            >
              <Checkbox
                checked={!!warrantyChecked}
                tabIndex={-1}
                disableRipple
                size="small"
                sx={{
                  p: 0.2,
                  color: "#1d72b8",
                  "&.Mui-checked": { color: "#1d72b8" },
                }}
                slotProps={{
                  input: { "aria-label": "Select 2 Year Extended Warranty" },
                }}
                onChange={() => {}}
              />
              1 - 2 Yr (Ext)
            </Button>
          </Box>

          <Typography
            variant="body2"
            sx={{
              color: "#59729b",
              fontSize: 12,
              mb: 1,
              mt: 0.5,
              px: 0.5,
              lineHeight: 1.5,
            }}
          >
            {modalContent.description}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          pb: 1.5,
          pt: 0.5,
          px: 1,
          width: "100%",
        }}
      >
        <Button
          type="button"
          variant="contained"
          color="primary"
          onClick={onNext}
          sx={{
            minWidth: 80,
            maxWidth: 120,
            fontWeight: 600,
            fontSize: 13,
            borderRadius: 2,
            py: 0.5,
            width: "100%",
            boxShadow: "0 2px 8px #1d72b80a",
            mx: "auto",
            display: "block",
            letterSpacing: 0.2,
            height: modalConfig.buttonHeight.mobile,
          }}
        >
          {modalContent.nextButton}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessModal;
